var _circle, _circle2, _circle3, _circle4, _path, _path2, _circle5, _circle6, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryLifeCoach = function SvgCategoryLifeCoach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.25,
    cy: 31,
    r: 14,
    fill: "#E2EAFF",
    transform: "rotate(-90 22.25 31)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.25,
    cy: 15,
    r: 4,
    fill: "#E2EAFF",
    transform: "rotate(-90 43.25 15)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.424,
    cy: 16.268,
    r: 1.417,
    stroke: "#0833A0",
    strokeWidth: 1.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.428,
    cy: 16.268,
    r: 1.417,
    stroke: "#0833A0",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0833A0",
    strokeWidth: 1.3,
    d: "M14.458 16.268h28.936"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0833A0",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M13.424 26.603c-1.034-1.206-3.432-2.067-4.909 0-1.846 2.583 2.153 5.683 4.909 6.717M13.683 26.602c1.033-1.206 3.432-2.067 4.908 0 1.846 2.583-2.152 5.684-4.908 6.717M13.424 18.335v5.684M47.011 24.535h-2.583m-3.1 8.268h3.1m0-8.268H42.81a2 2 0 0 0-2 2v.134a2 2 0 0 0 2 2h3.234a2 2 0 0 1 2 2v.134a2 2 0 0 1-2 2h-1.617m0-8.268v-1.033m0 9.301v1.033M44.428 17.818v3.86M26.859 16.268v23.77h4.134m0-23.77v19.635M31.51 46.238h4.683a1 1 0 0 0 1-1v-1.617a1 1 0 0 0-1-1H21.659a1 1 0 0 0-1 1v1.617a1 1 0 0 0 1 1h5.718M28.926 11.1V8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.926,
    cy: 14.201,
    r: 3.484,
    fill: "#fff",
    stroke: "#0833A0",
    strokeWidth: 1.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.926,
    cy: 14.201,
    r: 1.417,
    fill: "#fff",
    stroke: "#0833A0",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0833A0",
    strokeWidth: 1.3,
    d: "M23.759 41.037a1 1 0 0 1 1-1h8.334a1 1 0 0 1 1 1v.584a1 1 0 0 1-1 1H24.76a1 1 0 0 1-1-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0833A0",
    d: "M31.665 38.125a.672.672 0 1 1-1.343 0 .672.672 0 0 1 1.343 0M30.27 46.238a.672.672 0 1 1-1.344 0 .672.672 0 0 1 1.343 0"
  })));
};
export default SvgCategoryLifeCoach;